module.exports = __webpack_public_path__ + "static/media/Img_load-box_light.c97cde4a.svg";